import { inject, Injectable, Type } from '@angular/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';

@Injectable({
  providedIn: 'root'
})
export class AuthDialogService {
  private readonly dialog = inject(Dialog);

  private activeDialogRef: DialogRef<unknown> | null = null;

  async openSignIn(): Promise<void> {
    const { SignInComponent } = await import('../pages/sign-in/sign-in.component');

    this.openAuthDialog(SignInComponent, {
      width: '100%',
      maxWidth: '575px'
    });
  }

  async openOnboarding(): Promise<void> {
    const { OnboardingComponent } = await import(
      '../pages/onboarding/onboarding.component'
    );

    this.openAuthDialog(OnboardingComponent, {
      width: '100%',
      maxWidth: '1040px'
    });
  }

  closeActiveDialog(result?: unknown): void {
    this.activeDialogRef?.close(result);
    this.activeDialogRef = null;
  }

  private openAuthDialog(
    component: Type<unknown>,
    config: {
      width: string;
      maxWidth: string;
    }
  ): void {
    this.closeActiveDialog();

    const dialogRef = this.dialog.open(component, {
      ...config,
      disableClose: false,
      autoFocus: false,
      restoreFocus: true
    });

    this.activeDialogRef = dialogRef;

    dialogRef.closed.subscribe(() => {
      if (this.activeDialogRef === dialogRef) {
        this.activeDialogRef = null;
      }
    });
  }
}
